function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

// Pub/Sub System
const subscribers = new Map();

function subscribe(eventName, callback) {
  if (!subscribers.has(eventName)) {
    subscribers.set(eventName, new Set());
  }

  subscribers.get(eventName).add(callback);

  // Return unsubscribe function
  return () => {
    const eventSubscribers = subscribers.get(eventName);
    if (eventSubscribers) {
      eventSubscribers.delete(callback);
      if (eventSubscribers.size === 0) {
        subscribers.delete(eventName);
      }
    }
  };
}

function publish(eventName, data) {
  const eventSubscribers = subscribers.get(eventName);
  if (eventSubscribers) {
    eventSubscribers.forEach((callback) => {
      try {
        callback(data);
      } catch (error) {
        console.error(`Error in subscriber for ${eventName}:`, error);
      }
    });
  }
}

/**
 * Legacy focus management functions
 * These are used by Dawn theme components and should be replaced with DialogManager
 * @deprecated Use DialogManager instead
 */
let focusableElements = [];
let lastFocusedElement = null;

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      'summary, a[href], button:not([disabled]), [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), object, iframe'
    )
  ).filter(element => element.offsetParent !== null && !element.closest('[aria-hidden="true"]'));
}

function trapFocus(container, elementToFocus = container) {
  focusableElements = getFocusableElements(container);
  lastFocusedElement = elementToFocus || focusableElements[0];
  lastFocusedElement?.focus();

  container.addEventListener('keydown', handleFocusTrap);
}

function handleFocusTrap(e) {
  if (e.key !== 'Tab') return;

  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];

  if (e.shiftKey) {
    if (document.activeElement === firstFocusableElement) {
      e.preventDefault();
      lastFocusableElement.focus();
    }
  } else {
    if (document.activeElement === lastFocusableElement) {
      e.preventDefault();
      firstFocusableElement.focus();
    }
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('keydown', handleFocusTrap);
  elementToFocus?.focus();
}

// Helper function for keyboard navigation
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const target = event.target;
  const openDetailsElement = target.closest('details[open]');
  if (!openDetailsElement) return;
  
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', 'false');
  summaryElement.focus();
}
